import { Component, input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { startWith } from 'rxjs';
import { PasswordHintTestIds } from './password-hint.test-ids';

@Component({
  selector: 'app-password-hint',
  imports: [MatIcon],
  templateUrl: './password-hint.html',
  styleUrl: './password-hint.scss'
})
export class PasswordHint implements OnInit {
  control = input.required<AbstractControl>();
  confirmControl = input<AbstractControl | null>(null);
  rules = [
    { key: 'minlength', label: 'Mind. 14 Zeichen' },
    { key: 'case', label: 'Groß- und Kleinbuchtabe' },
    { key: 'number', label: '1 Zahl' },
    { key: 'specialChar', label: '1 Sonderzeichen' }
  ];
  protected readonly testIds = PasswordHintTestIds;

  get fulfilledCount(): number {
    if (!this.control().value) return 0;

    return this.allRules.filter(rule => this.isValid(rule.key)).length;
  }

  get allRules(): { key: string; label: string }[] {
    const baseRules = [...this.rules];

    if (this.confirmControl()) {
      baseRules.push({ key: 'passwordsMismatch', label: 'Passwörter stimmen überein' });
    }

    return baseRules;
  }

  ngOnInit(): void {
    this.control()
      .valueChanges?.pipe(startWith(this.control().value))
      .subscribe(() => {
        this.control().updateValueAndValidity({ emitEvent: false });
      });
  }

  isInvalid(key: string): boolean {
    if (!this.control()?.value) return false;

    if (key === 'passwordsMismatch') {
      return !!this.control()?.parent?.errors?.['passwordsMismatch'];
    }

    return !!this.control().errors?.[key];
  }

  isValid(key: string): boolean {
    if (!this.control()?.value) return false;

    if (key === 'passwordsMismatch') {
      const hasError = this.control()?.parent?.errors?.['passwordsMismatch'];
      const confirmHasValue = !!this.confirmControl()?.value;

      return confirmHasValue && !hasError;
    }

    return !this.control().errors?.[key];
  }

  isNeutral(): boolean {
    return !this.control().value;
  }
}
